import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=27072936&scoped=true"
import script from "./dataList.vue?vue&type=script&lang=js"
export * from "./dataList.vue?vue&type=script&lang=js"
import style0 from "./dataList.vue?vue&type=style&index=0&id=27072936&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27072936",
  null
  
)

export default component.exports